import React, { useCallback, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useSelector, useDispatch } from 'react-redux';
import { CLOSE_MULTIPLE_DOWNLOAD_MODAL } from '../../../../redux/types';
import { RootState } from '../../../../redux/store';
import useClickOutside from '../../../../common/hooks/useClickOutside';
import Icon from '../../icon/icon';
import Fade from '../../fade/fade';

import './multipleDownload.scss';

const modalElement = document.getElementById('modal-root');

export const MultipleDownloadModal = () => {
  const showModal = useSelector((state: RootState) => state.multipleDownload.showModal);
  const modalInfo = useSelector((state: RootState) => state.multipleDownload.modalInfo);
  const dispatch = useDispatch();

  const close = () => {
    dispatch({ type: CLOSE_MULTIPLE_DOWNLOAD_MODAL });
  };

  const modalRef = useRef(null);

  const handleEscape = useCallback(
    (event) => {
      if (event.keyCode === 27) close();
    },
    [close],
  );

  useEffect(() => {
    if (showModal) {
      setTimeout(() => {
        dispatch({ type: CLOSE_MULTIPLE_DOWNLOAD_MODAL });
      }, 3000)
    }
    if (showModal) document.addEventListener('keydown', handleEscape, false);
    return () => {
      document.removeEventListener('keydown', handleEscape, false);
    };
  }, [handleEscape, showModal]);

  useClickOutside(modalRef, close);

  return createPortal(
    (
      <Fade show={showModal} fadeOut>
        <div className={`${modalInfo && modalInfo.error ? 'multiple-download-modal-error' : 'multiple-download-modal-wrapper'}`}>
          <Icon name='fas fa-times-circle' className='multiple-download-modal-close' onClick={close} />
          <div className='multiple-download-modal-body' ref={modalRef}>
            {modalInfo && <span>{modalInfo.text}</span>}
          </div>
        </div>
      </Fade>
    ),
    modalElement,
  );
};

export default MultipleDownloadModal;
